"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValueConstants;
(function (ValueConstants) {
    ValueConstants["GlobalTenantId"] = "67e82acb-8071-4b9b-993f-ab71fb6eee2d";
    ValueConstants["TypeIdPrefix"] = "abb.local";
})(ValueConstants = exports.ValueConstants || (exports.ValueConstants = {}));
//# sourceMappingURL=ValueConstants.js.map